import React from 'react'
import dayjs from 'dayjs'

import { groupDependentFields } from '../../common/utils'
import PdfExport from './PdfExport'
import { Header, PageNumbers, Title } from './pdfContent'
import { tableStyles } from './styles'
import { formatFormField } from './pdfForms'

interface InitialAssessmentPdfExportProps {
  carer: any
  initialAssessment: {
    createdOn: string
    form: {
      formFields: any
      name: string
    }
    formData: any
  }
  resident: any
  disabled?: boolean
  style: React.CSSProperties
  title: string
}

export default class InitialAssessmentPdfExport extends React.Component<InitialAssessmentPdfExportProps> {
  // eslint-disable-next-line class-methods-use-this
  formatDate = (date: any) => dayjs(date).format('DD-MM-YYYY')

  // eslint-disable-next-line class-methods-use-this
  formatTime = (time: any) => dayjs(time).format('HH:mm')

  // eslint-disable-next-line class-methods-use-this
  getName = (item: any) => `${item.name.first} ${item.name.last}`

  getInitialAssessmentDoc = () => {
    const {
      carer,
      initialAssessment: {
        createdOn,
        form: { formFields, name },
        formData,
      },
      resident,
    } = this.props

    if (!formData || !formFields) return null

    const withDependentFields = groupDependentFields(formFields)
    const lastUpdateText = `${this.formatDate(createdOn)} at ${this.formatTime(
      createdOn
    )} - ${this.getName(carer)}`

    const content = [
      // @ts-ignore
      Header({
        title: `${this.getName(resident)} - ${name}`,
      }),
      Title({ title: 'Last update', style: 'h2' }),
      {
        text: lastUpdateText,
        textStyle: 'tableHeaderSmall',
        margin: [0, 0, 0, 30],
      },
    ]

    return {
      content: [
        ...content,
        ...withDependentFields.map((field) =>
          formatFormField({ formData, ...field })
        ),
      ],
      footer: PageNumbers,
      styles: tableStyles,
    }
  }

  getDocDefinition = () => {
    const { carer, initialAssessment, resident } = this.props
    return new Promise((resolve, reject) => {
      if (
        !carer ||
        !initialAssessment ||
        !initialAssessment.form ||
        !resident
      ) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('Data not provided')
      } else {
        resolve(this.getInitialAssessmentDoc())
      }
    })
  }

  render() {
    const { disabled, style, title } = this.props
    return (
      <PdfExport
        getDocDefinition={this.getDocDefinition}
        pdfTitle={title}
        style={style}
        disabled={disabled}
      />
    )
  }
}
